export default __webpack_public_path__ + "static/media/logo.b77e8ee6.png";